var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLebanon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 7h30v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#da352e",
    d: "M30 7H0V0h30zm0 17H0v-7h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4aa25a",
    d: "M14.76 7.5c-.13.51-.94.76-1 1.18.68-.01-.47.47-.61.65.82.46-.14.25-.29.73-.12.3-1.54.66-.85.9.3-.13.8-.19.65.31-.14.54-1.98.94-1.34 1.45.23-.02.4-.21.6-.3.44-.1.38.53 0 .57-1.83 1.1-1.68 1.67.31.59 1.32.48-1.68.73-1.24 1.2.91.35 1.97-1.1 2.69-.35.68.93-2.18 2.12-1.4 1.99.31-.35.9-.11 1.22-.46s1.06-.46 1.37-.16c.1.17.52.6.65.45.09-.84 1.08.38 1.34.25.06-.32-.46-.4-.61-.65-.48-.3-.8-1.95.04-1.79.57.41 1.27.12 1.9.29.29.07 1.39 1.04 1.13.26-.29-.53-1.76-.68-1.5-1.3.24-.29 1.54.63 1-.1-.5-.29-.8-.96-1.45-.87-.12-.42.68-.17.93-.27.5.06.14-.35-.16-.32-1.04-.18-1.01-.6.04-.32.33-.36-2.65-1.51-1.68-1.73 1.01.38.91.14.11-.35-.14-.13.13-.18.22-.13.24-.74-2.03-.63-2.07-1.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLebanon);
export default __webpack_public_path__ + "static/media/lebanon.6eeb53c5f7bf5017bb7a478ff9a48b08.svg";
export { ForwardRef as ReactComponent };